import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import { History } from 'history';
import { ApplicationState, reducers } from './';

export default function configureStore(history: History, initialState?: ApplicationState) {
    return configureReduxStore({
        reducer: reducers,
        preloadedState: initialState,
    });
}
